import { Options, Vue } from 'vue-class-component';
import PageTitleComponent from '@/sharedcomponents/pageComponents/pageTitle/PageTitleComponent.vue';
import { ReceiptPage, Signee, UsabillaInPageBlock } from '@/cms/definitions/content-types';
import store from '@/store/store';
import CookieFooter from '@/sharedcomponents/pageComponents/cookieFooter/cookieFooter.vue';
import VerticalStepComponent from './VerticalStepComponent.vue';
import UsabillaInPageComponent from '@/sharedcomponents/pageComponents/usabillaInPageComponent/UsabillaInPageComponent.vue';

import ModelMapper from './ModelMapper';
import { getDomain, handleIdleLogout, isDevelop } from '@/services/environmentService';
import { getProposal } from '@/services/apiService';
import { mapState } from 'vuex';
import { Log } from '@/appinsights/logging/log';
import { nextTick } from 'vue';
import { setError } from '@/services/PageService';

@Options({
	name: 'ReceiptComponent',
	components: {
		PageTitleComponent,
		VerticalStepComponent,
		UsabillaInPageComponent,
		CookieFooter,
	},
	computed: mapState<any>({
		//hasError: (state) => store.state.hasError,
		mockedDataLoaded: (state) => store.state.mockedDataLoaded,
	}),
	props: {
		model: Object,
	},
})
export default class ReceiptComponent extends Vue {
	public model: ReceiptPage; // epi contentModel
	public usabillaBlock: UsabillaInPageBlock = null; // epi contentModel
	public usabillaBlockLeaveIntent: any = null;
	public renderPage = false;
	public headline = '...';
	public policy: any;
	public proposalIdLabel: string;
	public proposalId: string;
	public isDevelop = isDevelop;

	public domain = getDomain();
	public loadError = null;
	public allSignaturesDone = false;

	public mockedDataLoaded!: boolean;

	public beforeCreate() {
		handleIdleLogout(this.domain.url, 5);
	}

	public beforeMount() {
		this.init();
	}

	private async init() {
		store.state.mockedDataLoaded = false;
		store.state.showSpinner = true;
		try {
			const query = this.$route.query;
			if (query) {
				store.state.ProposalContext.quote_id = query.quote as string;
				store.state.ProposalContext.customerNo = query.customer_no as string;
				store.state.ProposalContext.signatureId = query.signature as string;
				store.state.ProposalContext.timestamp = (query.timestamp as string) ?? '';
			}

			const proposal = await getProposal(true);
			if (isDevelop && proposal?.status === 'TEST_DATA') {
				store.state.mockedDataLoaded = true;
				store.state.ProposalContext.quote_id = 'MOCK ' + proposal.data.quote_id;
				store.state.ProposalContext.customerNo = 'MOCK custNo';
				store.state.ProposalContext.signatureId = 'dummy signatureID';
				store.state.ProposalContext.timestamp = '01011970';
			}

			this.handleSignatures(proposal);

			this.headline = this.allSignaturesDone ? this.model.headline : this.model.headlineMissingSignature;

			store.state.ProposalContext.originalRequest = proposal.data;
			const modelMapper: ModelMapper = new ModelMapper(proposal, this.model);
			this.policy = modelMapper.getReceiptPolicyDetails();
			this.proposalIdLabel = this.model.offerIdLabel;
			this.proposalId = store.state.ProposalContext.quote_id;
			this.setupUsabilla();

			if (isDevelop && store.state.mockedDataLoaded) {
				// fake wait
				setTimeout(() => {
					this.renderPage = true;
					store.state.showSpinner = false;
				}, 2500);
			} else {
				this.renderPage = true;
				store.state.showSpinner = false;
			}
		} catch (error) {
			Log.exception('Error mounting receipt', error, { quoteId: store.state.ProposalContext.quote_id });

			store.state.showSpinner = false;
			nextTick(() => {
				setError(this.model.errorMessage ?? 'Kvittering kunne ikke hentes');
				this.loadError = store.state.errorMessage;
				store.state.hasError = true;
			});
		}
	}

	private handleSignatures(proposal) {
		const signees: Signee[] = proposal?.data?.signees;
		this.allSignaturesDone = true;
		for (const signee of signees || []) {
			if (!signee.signed) {
				this.allSignaturesDone = false;
				return;
			}
		}
	}

	public get subtitle() {
		let subtitle = this.model.subTitle;
		if (!this.allSignaturesDone) {
			subtitle = this.model.subTitleMissingSignature;
		}

		if (!subtitle) {
			return undefined;
		}
		return subtitle.trim() === '' ? undefined : subtitle;
	}

	private setupUsabilla(): void {
		const items = this.model.contentArea?.items;
		if (items?.length > 0) {
			items.forEach((block) => {
				if (block?.content.contentType === 'UsabillaInPageBlock') {
					this.usabillaBlock = block.content;
				}
			});
		}
	}

	public get showSpinner() {
		return store.state.showSpinner;
	}

	public nextStep() {
		store.state.showSpinner = true;
		location.href = getDomain().url;
	}
}
